import { useState, useEffect, useContext } from "react";
import { reportFolioServices } from "../../../../../../../utils/constants/callService";
import { getAreaWithDepartments } from "../../../../../../../utils/methods/geServiceWithItemsFormat";
import { Item, ObjectGeneric } from "../../../../../../../utils/types/generals";
import { CategoryInterface, DropListSubCategorie, FormContext } from "../Context";
import { OptionsMostFrequentArray } from "../../../../../../../service/questionarie/response";
import { formatFrequentOptions } from "../../../../../../../service/reportFolio/format/options";

export const useGetData = () => {
  const [areas, setAreas] = useState<Item[]>([]);
  const [departments, setDepartments] = useState<Item[]>([]);
  const [loading, setLoading] = useState(true);
  const [unitys, setUnitys] = useState<Item[]>([]);
  const [isAreasLoaded, setIsAreasLoaded] = useState(false);
  const [providers, setProviders] = useState<Item[]>([]);
  const { setConfig, config } = useContext(FormContext);
  const [options, setOptions] = useState<OptionsMostFrequentArray>([]);
  const [notOptions, setNotOptions] = useState(false)
  const [isOptionsLoaded, setIsOptionsLoaded] = useState(false);
  const [loaderDetail, setLoaderDetail] = useState(false);


  const fetchAreas = async () => {
    try {
      const response = await getAreaWithDepartments();
      setAreas(response);
      setIsAreasLoaded(true);
      return response;
    } catch (error) {
      console.error("Error fetching areas:", error);
      return [];
    } finally {
      setLoading(false);
    }
  };

  const fetchFrequentOptions = async () => {
    try {
      setIsOptionsLoaded(true)
      const response = await reportFolioServices.getFrequentOptions('corrective');
      if (!response.errors && response.length != 0) {
        const { options } = formatFrequentOptions({ response })
        setOptions(options);
      } else {
        setNotOptions(true)
      }
      //setIsOptionsLoaded(false)
      return response;
    } catch (error) {
      console.error("Error fetching options:", error);
      return [];
    } finally {
      setIsOptionsLoaded(false);
    }
  };

  const fetchUnitys = async () => {
    try {
      const response = await reportFolioServices.getUnitys();
      // Formatear las unidades para el CustomSelect
      //@ts-ignore
      const formattedUnitys = response.map((unity: any) => ({
        label: `${unity.name}`,
        value: unity.id,
        extraData: {
          email: unity.email,
          address: unity.address,
          phone: unity.phone,
          timeZone: unity.storeTimeZone,
          user: unity.user
        }
      }));
      setUnitys(formattedUnitys);
      return formattedUnitys;
    } catch (error) {
      console.error("Error fetching unitys:", error);
      return [];
    }
  }

  useEffect(() => {
    fetchAreas();
    fetchUnitys();
  }, []);

  const loadDepartmentsByArea = async (selectedArea: ObjectGeneric) => {
    let currentAreas = areas;

    if (areas.length === 0) {
      currentAreas = await fetchAreas();
    }

    const area = currentAreas.find(area => Number(area.value) === Number(selectedArea.value));

    if (area && area.departments) {
      const areaDepartments: Item[] = area.departments.map((dept: { name: any; id: { toString: () => any; }; }) => ({
        label: dept.name,
        value: dept.id
      }));

      setDepartments(areaDepartments);
      return areaDepartments;
    } else {
      setDepartments([]);
      return [];
    }
  };

  const getCorrectiveData = async (id: string) => {
    try {
      setLoaderDetail(true)
      const response = await reportFolioServices.getCorrectiveData({ id });
      setLoaderDetail(false)
      return response;
    } catch (error) {
      console.error("Error fetching categories:", error);
      return null;
    }
  }

  const getProvidersForUnit = async (storeId: string | number, departmentId: string | number) => {
    try {
      const response = await reportFolioServices.getProvidersToAssign({
        storeId,
        departmentId
      });

      // Formatear los proveedores para el CustomSelect
      const formattedProviders = response.map((provider: any) => ({
        label: `${provider.firstName} ${provider.lastName}`,
        value: provider.id
      }));

      setProviders(formattedProviders);
      return formattedProviders;
    } catch (error) {
      console.error("Error fetching providers:", error);
      setProviders([]);
      return [];
    }
  };

  const getConfig = async (areaId: string | number, departmentId: string | number) => {
    try {
      const response = await reportFolioServices.getConfigGeneral({
        areaId,
        departmentId
      });
      setConfig(response);
      if (response.errors) return []
      return response;
    } catch (error) {
      console.error("Error fetching config:", error);
      setConfig(null);
      return null;
    }
  };

  const createFolio = async (body: ObjectGeneric) => {
    const response = await reportFolioServices.createFolio(body)
    return response
  }

  const editFolio = async (body: ObjectGeneric, id: number) => {
    const response = await reportFolioServices.editionFolio(body, id)
    return response
  }


  const getCategoriesByDepartment = async (departmentId: string, type: string = 'corrective') => {
    try {
      const response = await reportFolioServices.getCategoriesByDepartment({ departmentId, type });
      return formatCategories(response);
    } catch (error) {
      console.error("Error fetching categories:", error);
      return null;
    }
  }

  const formatCategories = (data: any[]): CategoryInterface[] => {
    // Función recursiva para transformar los dropdowns
    const mapDropList = (dropDowns: any[]): DropListSubCategorie[] => {
      if (!Array.isArray(dropDowns)) return [];

      return dropDowns.map((item) => ({
        label: item.name,
        value: item.currentDropDownId,
        requestText: item.requiredText,
        dropList: mapDropList(item.nextValues || []),
        currentNode: item.currentNode,
      }));
    };

    // Mapeo principal de categorías
    return data.map((category) => ({
      id: category.id,
      name: category.name,
      subcategories: (category.subcategories || []).map((sub: any) => ({
        id: sub.id,
        name: sub.name,
        categoryId: sub.categoryId,
        requestText: sub.requestText,
        textRequest: sub.requestText ? "true" : undefined,
        text: !!sub.requestText,
        priorityId: sub.priorityId,
        supplierId: sub.supplierId,
        priority: sub.priority
          ? {
            id: sub.priority.id,
            name: sub.priority.name,
          }
          : { id: 0, name: "" },
        user: sub.user
          ? {
            id: sub.user.id,
            curp: sub.user.curp,
            firstName: sub.user.firstName,
            lastName: sub.user.lastName,
            email: sub.user.email,
          }
          : null,
        version: sub.version,
        dropList: mapDropList(sub.dropDownLinks || []),
      })),
    }));
  };

  return {
    areas,
    departments,
    loadDepartmentsByArea,
    loading,
    unitys,
    isAreasLoaded,
    getCategoriesByDepartment,
    getProvidersForUnit,
    providers,
    config,
    getConfig,
    createFolio,
    getCorrectiveData,
    editFolio,
    options,
    notOptions,
    isOptionsLoaded,
    fetchFrequentOptions,
    loaderDetail
  };

};